import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { VirtualConnectionTablesDisplayGridRowDataFragmentGql } from './VirtualConnectionTablesDisplayGridRowDataFragmentGql';

export const FlowUpstreamVirtualConnectionTablesFilteredByFlowOutputFieldQueryGql: DocumentNode = gql`
query FlowUpstreamVirtualConnectionTablesFilteredByFlowOutputFieldQuery(
  $flowVizportalUrlId: String!,
  $selectedFlowOutputFieldId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: VirtualConnectionTableSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!
) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    outputFieldsConnection(filter: { id: $selectedFlowOutputFieldId }) {
      nodes {
        upstreamVirtualConnectionTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...VirtualConnectionTablesDisplayGridRowDataFragment
          }
        }
        maxDownstreamDatasources: upstreamTablesConnection(
          orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection { totalCount }
          }
        }
        maxDownstreamWorkbooks: upstreamTablesConnection(
          orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection { totalCount }
          }
        }
      }
    }
  }
}
${VirtualConnectionTablesDisplayGridRowDataFragmentGql}
`;
